// SPDX-License-Identifier: MIT

// Built-in tracker loaders for common third-party pixels/tools. Each factory
// takes the site's ID and returns { onAccept, onReject, onRouteChange } to wire
// onto a consent category via the `trackers` option. The plugin knows HOW to
// load each tracker; the site supplies WHICH id — so the plugin stays generic.
//
// onAccept loads + records the entry page view (idempotent), onReject unloads
// (or reloads to drop a pixel that can't be torn down), onRouteChange fires a
// page view on SPA navigation. All run in the browser when the category's
// consent is granted.

/* eslint-disable */

// Facebook Pixel — gtag/Consent-Mode-independent, so it must be gated here.
const facebookPixel = (pixelId) => ({
  onAccept() {
    if (!window.fbq) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', pixelId);
    }
    window.fbq('track', 'PageView');
  },
  onReject() {
    // fbevents.js can't be unloaded; reload to drop it for the session.
    if (window.fbq) window.location.reload();
  },
  onRouteChange() {
    if (window.fbq) window.fbq('track', 'PageView');
  },
});

// Reddit Pixel.
const redditPixel = (pixelId) => ({
  onAccept() {
    if (!window.rdt) {
      !(function (w, d) {
        if (!w.rdt) {
          var p = (w.rdt = function () {
            p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
          });
          p.callQueue = [];
          var t = d.createElement('script');
          t.src = 'https://www.redditstatic.com/ads/pixel.js';
          t.async = !0;
          var s = d.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(t, s);
        }
      })(window, document);
      window.rdt('init', pixelId);
    }
    window.rdt('track', 'PageVisit');
  },
  onReject() {
    if (window.rdt) window.location.reload();
  },
  onRouteChange() {
    if (window.rdt) window.rdt('track', 'PageVisit');
  },
});

// Intercom messenger. Has a clean shutdown, so no reload needed on reject.
const intercom = (appId) => ({
  onAccept() {
    window.intercomSettings = { app_id: appId };
    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/' + appId;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();
    window.Intercom('boot', { app_id: appId });
  },
  onReject() {
    if (window.Intercom) window.Intercom('shutdown');
  },
  onRouteChange() {
    if (window.Intercom) window.Intercom('update');
  },
});

/* eslint-enable */

// Merges several trackers into one { onAccept, onReject, onRouteChange } so a
// single consent category can gate multiple trackers (e.g. marketing = FB + Reddit).
const combineTrackers = (trackers) => ({
  onAccept() {
    trackers.forEach((t) => t.onAccept && t.onAccept());
  },
  onReject() {
    trackers.forEach((t) => t.onReject && t.onReject());
  },
  onRouteChange() {
    trackers.forEach((t) => t.onRouteChange && t.onRouteChange());
  },
});

module.exports = { facebookPixel, redditPixel, intercom, combineTrackers };
